import { Box, Icon, Text } from '@betty/moonlight';

function PartnershipDesktopContent() {
  return (
    <Box
      margin="space-800"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Icon name="mapleLeafs" height={80} width={80} />
      <Text
        variant="h4"
        gradient="darkSurfaceAccent"
        borderRadius="radius-200"
        textAlign="center"
        maxWidth={650}
      >
        An Official Online Casino Partner of the Toronto Maple Leafs and Toronto
        Raptors
      </Text>
      <Icon name="torontoRaptors" height={80} width={80} />
    </Box>
  );
}

export default PartnershipDesktopContent;
